module.exports = __webpack_public_path__ + "img/chevron-left.c2c25746.svg";